import { INetwork } from '@/types'
import { isEvmChain, isSolanaChain } from '@/utils/chain'
import { WalletContextType } from '@/wallets/types'

const WALLET_STORAGE_KEY = 'connected_wallets'

export interface StoredWalletData {
  walletType: string
  address: string
  networkInfo: INetwork
  connectedAt?: string
}

export const WalletStorage = {
  saveWallets(connectedWallets: Record<string, WalletContextType>) {
    try {
      const dataToSave = Object.entries(connectedWallets).reduce(
        (acc, [network, context]) => {
          if (!context.wallet) return acc

          acc[network] = {
            walletType: context.wallet.key,
            address: context.address || '',
            networkInfo: context.networkInfo || ({} as INetwork),
            connectedAt: context?.connectedAt?.toString() || '',
          }
          return acc
        },
        {} as Record<string, StoredWalletData>
      )

      localStorage.setItem(WALLET_STORAGE_KEY, JSON.stringify(dataToSave))
    } catch (error) {
      console.error('Error saving wallet data:', error)
    }
  },

  getSaveWallets() {
    const savedData = localStorage.getItem(WALLET_STORAGE_KEY)
    if (!savedData) return
    const parsed = JSON.parse(savedData) as Record<string, StoredWalletData>
    return parsed
  },

  getSaveEvmWallet() {
    const parsed = WalletStorage.getSaveWallets()
    if (!parsed) return
    return Object.entries(parsed).find(([network]) => isEvmChain(network))
  },
  getSaveSolWallet() {
    const parsed = WalletStorage.getSaveWallets()
    if (!parsed) return
    return Object.entries(parsed).find(([network]) => isSolanaChain(network))
  },

  clearSavedWallets() {
    localStorage.removeItem(WALLET_STORAGE_KEY)
  },

  removeNetwork(network: string) {
    try {
      const savedData = localStorage.getItem(WALLET_STORAGE_KEY)
      if (!savedData) return

      const parsed = JSON.parse(savedData)
      delete parsed[network]

      localStorage.setItem(WALLET_STORAGE_KEY, JSON.stringify(parsed))
    } catch (error) {
      console.error('Error removing network:', error)
    }
  },
}
